import { HttpClient } from "helpers";
import {BaseResponseType, DataGridRequest, PagedResponseType} from "services/shared-models/sharedTypes";
import {
  GetAllTasksResponse,
  MyCompletedTaskResult,
  OpenPublishingTaskResult,
  ReAssignRequest,
  ReAssignResponse, TaskInfoResult
} from "./models/tasksTypes";
import { AxiosResponse } from "axios";

export const TasksService = {
  getMyTasks: async (data: DataGridRequest) => {
 
    return await HttpClient.post<GetAllTasksResponse>("/api/Tasks/GetMyTasks", data);
  },
  exportTasksToExcel: async (data: DataGridRequest) => {
    return await HttpClient.post<AxiosResponse<Blob>>("/api/Tasks/ExportTasksToExcel", data, {
      responseType: "blob",
    });
  },
  openPublishingOrderTask: async (serialGID: string) => {
    return await HttpClient.get<OpenPublishingTaskResult>(
      `/api/Tasks/OpenPublishingOrderTask/${serialGID}`,
    );
  },
  getTasksByUserId: async (data: DataGridRequest, userId: string) => {
    return await HttpClient.post<GetAllTasksResponse>(`/api/Tasks/GetTasksByUserId/${userId}`, data);
  },
    reAssignTask: async (data: ReAssignRequest) => {
  return await HttpClient.post<ReAssignResponse>(`/api/Tasks/ReAssignTask`, data);
},
    getMyCompletedTasks: async (data: DataGridRequest) => {
  return await HttpClient.post<PagedResponseType<MyCompletedTaskResult>>("/api/Tasks/GetAllMyCompletedTasks", data);
},
    exportAllMyCompletedTasksToExcel: async (data: DataGridRequest) => {
  return await HttpClient.post<AxiosResponse<Blob>>("/api/Tasks/ExportAllMyCompletedTasksToExcel", data, {
    responseType: "blob",
  });
  
},
  getOrderBySerialGid: async (serialId: string) => {
    return await HttpClient.get  <BaseResponseType<TaskInfoResult>>(`/api/Tasks/GetOrderBySerialGid/${serialId}`);
  },
};
